export function isEqual<T>(first: T, second: T): boolean {
  if (first === second) return true;
  if ((first == null || second == null) && (first || second)) return false;

  const t1 = first?.constructor.name;
  const t2 = second?.constructor.name;
  if (t1 !== t2) return false;

  if (t1 === "Array") {
    const firstArray = first as unknown[];
    const secondArray = second as unknown[];
    if (firstArray.length !== secondArray.length) return false;
    for (let i = 0; i < firstArray.length; i++) {
      if (!isEqual(firstArray[i], secondArray[i])) return false;
    }
    return true;
  }

  if (t1 === "Object") {
    const firstObj = first as Record<string, unknown>;
    const secondObj = second as Record<string, unknown>;
    const k1 = Object.keys(firstObj);
    const k2 = Object.keys(secondObj);
    if (k1.length !== k2.length) return false;

    for (const key of k1) {
      const v1 = firstObj[key];
      const v2 = secondObj[key];
      if (v1 === v2) continue;

      const ct = v1?.constructor.name;
      if ((ct === "Array" || ct === "Object") && !isEqual(v1, v2)) return false;

      if (v1 !== v2) return false;
    }
    return true;
  }

  return first === second;
}
